import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {SepaError} from "../sepa-error.i";

@Injectable()
export class SepaErrorService {

    constructor(private http: HttpClient) {
    }

    public getRetentionsErrors(): Observable<Array<SepaError>> {
        return this.http.get<Array<SepaError>>(`api/client/dictionary/sepa_error/retention`);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/sepa-error.service.ts